module.exports = __webpack_public_path__ + "img/aduana-3.dc92c388.svg";